import { Plan } from './components/Plan';
import withTableController from '../../../../HOC/tableController/withTableControllerForEvaluation';

const Table21 = withTableController(({ planing, handlePlaning, childToParent, status, evaluatePlaning }) => (
  <Plan planing={planing} handlePlaning={handlePlaning} childToParent={childToParent} status={status} evaluatePlaning={evaluatePlaning} />
));

export default Table21;
